var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useMemo } from 'react';
import { percent, pxWithAuto, withMemo } from '@tencent/gems-shared';
function iGetInjectSchema(schema) {
    return Object.entries(schema).reduce(function (maps, _a) {
        var _b = __read(_a, 2), key = _b[0], inject = _b[1].inject;
        if (!inject) {
            return maps;
        }
        var items = Array.isArray(inject) ? inject : [inject];
        items.forEach(function (_a) {
            var attr = _a.attr, selector = _a.selector, format = _a.format;
            var iAttr = Array.isArray(attr) ? attr : [attr || key];
            var iSelector = Array.isArray(selector) ? selector.join(', ') : selector;
            var iFormat = typeof format === 'function' ? format : function (i) { return i.toString(); };
            if (format === 'px') {
                iFormat = pxWithAuto;
            }
            else if (format === 'percent') {
                iFormat = percent;
            }
            maps.push({ key: key, attr: iAttr, selector: iSelector, format: iFormat });
        });
        return maps;
    }, []);
}
var getInjectSchema = withMemo(iGetInjectSchema);
function formatInjectStyles(scope, style, schema) {
    return getInjectSchema(schema)
        .reduce(function (accu, _a) {
        var key = _a.key, attr = _a.attr, selector = _a.selector, format = _a.format;
        var v = style[key];
        if (!v) {
            return accu;
        }
        var value = format(v);
        accu.push("\t#" + scope + " " + selector + " { " + attr.map(function (i) { return i + ": " + value; }).join('; ') + " }");
        return accu;
    }, [])
        .join('\n');
}
// 用于处理 Schema 中的样式注入，详见：https://vision.oa.com/docs/dev-style-inject/#示例
export function StyleInjectHandler(_a) {
    var _b = _a.instance, key = _b.key, _c = _b.component, styleForm = _c.styleForm, injectStyle = _c.injectStyle, style = _b.style, scope = _a.scope, children = _a.children;
    var cssProps = useMemo(function () { return (injectStyle ? formatInjectStyles(scope, style, styleForm) : null); }, [style]);
    var entry = useMemo(function () {
        if (!injectStyle) {
            return;
        }
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.setAttribute('class', "injected-styles-component-" + key);
        window.__iframeWindow.document.head.appendChild(style);
        return style;
    }, [key]);
    useEffect(function () {
        if (!injectStyle) {
            return;
        }
        entry.innerHTML = cssProps;
        window.__iframeWindow.document.head.appendChild(entry);
        return function () {
            window.__iframeWindow.document.head.removeChild(entry);
        };
    }, [cssProps, entry]);
    return children;
}
//# sourceMappingURL=StyleInjectHandler.js.map